import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography, 
  Box,
  CircularProgress
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { toast } from 'react-toastify';

import { gallery as galleryApi } from '../../../utils/api';

const DeleteConfirmationModal = ({ open, onClose, onConfirm, galleryId }) => {
  const { t } = useTranslation('gallery');
  const [loading, setLoading] = useState(false);
  
  const handleDelete = async () => {
    try {
      setLoading(true);
      await galleryApi.delete(galleryId);
      onConfirm();
    } catch (error) {
      console.error('Error deleting gallery:', error);
      toast.error(error.message || t('messages.deleteError'));
      onClose();
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Dialog 
      open={open} 
      onClose={loading ? null : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {t('actions.delete')}
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <WarningIcon color="warning" sx={{ fontSize: 40, mr: 2 }} />
          <Typography variant="body1">
            {t('messages.confirmDelete')}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          {t('messages.adminOnly')}
        </Typography>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t('actions.cancel')}
        </Button>
        <Button 
          variant="contained" 
          color="error" 
          onClick={handleDelete}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : t('actions.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal; 